/**
 * Destino depois do login (`?next=`): só caminhos internos. Sem isto, um link
 * `/login?next=https://site-falso` mandaria o usuário recém-logado para fora da plataforma
 * (redirecionamento aberto, útil para phishing).
 */
export function safeNext(next: string | null): string {
  if (!next || !next.startsWith("/") || next.startsWith("//") || next.startsWith("/\\")) return "/";
  return next;
}
